import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export const uploadPatientDiagram = async (file, patientId) => {
  const storage = getStorage();
  const uniqueId = uuidv4();
  const storageRef = ref(storage, `PatientFiles/Patient${patientId}/Diagrams/${uniqueId}.svg`);
  
  const metadata = { contentType: "image/svg+xml" };
  await uploadBytes(storageRef, file, metadata);
  return await getDownloadURL(storageRef);
};